<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Penjadwalan",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "NIP", name: "nip" },
      { width: "auto", label: "Nama", name: "nama" },
      { width: "auto", label: "Tanggal Mulai", name: "waktu_mulai" },
      { width: "auto", label: "Tanggal Selesai", name: "waktu_selesai" },
      { width: "auto", label: "Keterangan", name: "total_keterangan" },
      { width: "200px", label: "Aksi", name: "-" },
    ];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Report Proctor Peserta - Detail List Peserta",
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,

      tableData: {
        columns: columns,
        sortKey: "kode_tes",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          draw: 0,
          page: 1,
          per_page: 10,
          search: "",
          column: "kode_tes",
          dir: "asc",
          idjadwal: this.$route.query.idjadwal,
          idjadwal_batch: this.$route.query.idjadwal_batch,
          nama: "",
          nip: "",
          tanggal_mulai: "",
          tanggal_selesai: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },
    };
  },
  mounted() {
    let self = this;
    // self.cekAksesMenu();
    self.getDataTable();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      const [datePart, timePart] = date.split(" ");
      const [year, month, day] = datePart.split("-");
      return `${day}-${month}-${year} ${timePart}`;
    },

    getDataTable(resetPage = true) {
      this.tableData.filter.page = resetPage ? 1 : this.tableData.filter.page;
      let self = this;
      self.tableData.loading = true;
      self.tableData.filter.draw++;

      var config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-proctor-peserta/list-peserta-jadwal-asesmen",
        params: self.tableData.filter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            let payload = response_data.data;
            let pesertaPagination = payload.list_peserta || {};

            self.tableData.data = pesertaPagination.data || [];
            
            self.configPagination(pesertaPagination);
            self.tableData.pagination.currentPage =
              pesertaPagination.current_page;
            self.tableData.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong.",
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir =
        self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    onChangeJadwal() {
      this.tableData.idbatch = null;
      this.tableData.idjadwal = this.selected_id_jadwal?.idjadwal;
      this.searchBatch(true, "");
    },
    backButton(){
      this.$router.push({
        name: "report-proctor-peserta-detail-batch",
        query: { idjadwal: this.$route.query.idjadwal },
      });
    },
    detail(row) {
      this.$router.push({
        name: "report-proctor-peserta-detail-per-peserta",
        query: { idjadwal: row.idjadwal, idjadwal_batch: row.idjadwal_batch, idjadwal_peserta: row.idjadwal_peserta },
      });
    },
    exportExcel() {
      let self = this;

      Swal.fire({
        title: "Sedang memproses...",
        text: "Harap tunggu, export Excel sedang diproses.",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/export-list-peserta",
        params: {
          idjadwal: self.tableData.filter.idjadwal,
          idjadwal_batch: self.tableData.filter.idjadwal_batch,
          nama: self.tableData.filter.nama,
          nip: self.tableData.filter.nip,
          tanggal_mulai: self.tableData.filter.tanggal_mulai,
          tanggal_selesai: self.tableData.filter.tanggal_selesai,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const contentDisposition = response.headers["content-disposition"];
          let fileName = "export-list-peserta.xlsx";
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?(.+)"?/);
            if (match) fileName = match[1];
          }
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          Swal.fire({
            icon: "success",
            title: "Berhasil!",
            text: "Export Excel berhasil diunduh.",
            timer: 2000,
            showConfirmButton: false,
          });
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: "error",
            title: "Gagal!",
            text: "Terjadi kesalahan saat export Excel.",
          });
        });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- bagian navigasi halaman -->
              <div class="col-md-12 d-flex justify-content-between align-item-center">
                <div>
                  <b-button
                    size="sm"
                    variant="danger"
                    class="fw-bold"
                    @click="backButton"
                  >
                    <i class="fa fa-arrow-left me-1"></i>
                    Kembali
                  </b-button>
                </div>

                <div>
                  <b-button
                    size="sm"
                    variant="success"
                    class="fw-bold"
                    @click="exportExcel"
                  >
                    <i class="fa fa-file-excel me-1"></i>
                    Export
                  </b-button>
                </div>
              </div>
              <!-- --------------------- -->

              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div class="form-group col-md-4 mb-2">
                    <label for="statusTable">Nama</label>
                    <input
                      type="text"
                      class="form-control"
                      id="tanggal_selesai"
                      placeholder="Filter Nama"
                      v-model="tableData.filter.nama"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-4 mb-2">
                    <label for="statusTable">NIP</label>
                    <input
                      type="nip"
                      class="form-control"
                      id="tanggal_selesai"
                      placeholder="Filter NIP"
                      v-model="tableData.filter.nip"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-2 mb-2">
                    <label for="filterTanggalMulai">Tanggal Mulai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalMulai"
                      v-model="tableData.filter.tanggal_mulai"
                      @change="getDataTable()"
                    />
                  </div>
                  <div class="form-group col-md-2 mb-2">
                    <label for="filterTanggalSelesai">Tanggal Selesai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalSelesai"
                      v-model="tableData.filter.tanggal_selesai"
                      @change="getDataTable()"
                    />
                  </div>
                  <!-- <div class="p-2 col-md-2 mt-3">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="getDataTable()"
                    >
                      Filter
                    </button>
                  </div> -->
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-12">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            id="showpaginatetable"
                            style="width: 100%"
                            v-model="tableData.per_page"
                            @change="
                              tableData.page = 1;
                              getDataTable();
                            "
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                  <!-- <div class="col-md-5">&nbsp;</div> -->
                  <!-- <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="searchTable"
                      placeholder="Cari Data ..."
                      v-model="tableData.search"
                      @input="getDataTable()"
                    />
                  </div> -->
                </div>
              </div>
              <datatable
                :columns="tableData.columns"
                :sortKey="tableData.sortKey"
                :sortOrders="tableData.sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="tableData.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>

                  <tr
                    v-else-if="!tableData.data || tableData.data.length === 0"
                    class="text-center"
                  >
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>

                  <tr
                    v-else
                    v-for="(row_data, key_data) in tableData.data"
                    :key="row_data.idjadwal_peserta"
                  >
                    <td class="text-center">
                      {{
                        (tableData.pagination.currentPage - 1) *
                          (tableData.filter.per_page || 10) +
                        key_data +
                        1
                      }}
                    </td>
                    <td class="text-center">{{ row_data.nip }}</td>
                    <td><span class="text-nowrap">{{ row_data.nama }}</span></td>
                    <td class="text-center">
                      <span class="text-nowrap">{{ formatDate(row_data.waktu_mulai) }}</span>
                    </td>
                    <td class="text-center">
                      <span class="text-nowrap">{{ formatDate(row_data.waktu_selesai) }}</span>
                    </td>
                    <td class="text-center">
                      <span
                        class="badge"
                        :class="{
                          'bg-success': row_data.total_is_valid === true,
                          'bg-secondary': row_data.total_is_valid === false && row_data.total_keterangan === 'Pending',
                          'bg-danger': row_data.total_is_valid === false && row_data.total_keterangan !== 'Pending',
                        }"
                      >
                        {{ row_data.total_keterangan ?? "-" }}
                      </span>
                    </td>
                    <td class="text-center">
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn btn-info btn-sm"
                          @click="detail(row_data)"
                        >
                          <i class="fa fa-external-link-alt"></i> Detail
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination
              :pagination="tableData.pagination"
              @to-page="toPage"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
